// src/components/RegistrationForm.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import "../dell.css";
import { firebaseAPI } from "../firebaseConfig";
import axiosInstance from "../utils/axiosInstance";

function UserTable({ users }) {
  return (
    <div>
      <h2>User Table</h2>
      <table>
        <thead>
          <tr>
            <th>Username</th>
            <th>Email</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user._id}>
              <td>{user.username}</td>
              <td>{user.email}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function RegistrationForm() {
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    gradyear: "",
    university: "",
    hobbies: "",
  });
  const [users, setUsers] = useState([]);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axiosInstance.get(
        "http://localhost:5000/api/users"
      );
      setUsers(response.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosInstance.post(
        "http://localhost:5000/api/users/register",
        formData
      );
      ////console.log(response.data);
      // Handle success (e.g., show a success message to the user)
      alert("successfully submitted!");
      // After successful registration, fetch updated users
      fetchUsers();
    } catch (error) {
      console.error("Error:", error);
      // Handle error (e.g., show an error message to the user)
    }
  };

  return (
    <div className="registration-form">
      <h2>Registration Form</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Username:</label>
          <input
            type="text"
            name="username"
            value={formData.username}
            onChange={handleChange}
          />
        </div>
        <div>
          <label>Email:</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
        </div>
        <div>
          <label>Graduation year:</label>
          <input
            type="text"
            name="gradyear"
            value={formData.gradyear}
            onChange={handleChange}
          />
        </div>
        <div>
          <label>University:</label>
          <input
            type="text"
            name="university"
            value={formData.university}
            onChange={handleChange}
          />
        </div>
        <div>
          <label>Hobbies:</label>
          <input
            type="text"
            name="hobbies"
            value={formData.hobbies}
            onChange={handleChange}
          />
        </div>
        <button type="submit">Register</button>
      </form>
      <UserTable users={users} />
    </div>
  );
}

export default RegistrationForm;
